import { getNonPublicIfAvailable } from '@trello/business-logic/member';

import type { TrelloMember } from './TrelloMember';

export const sortMentions = (a: TrelloMember, b: TrelloMember) => {
  const aFullName = getNonPublicIfAvailable(a, 'fullName') ?? '';
  const bFullName = getNonPublicIfAvailable(b, 'fullName') ?? '';

  if (aFullName > bFullName) {
    return 1;
  } else if (a.username > b.username) {
    return 1;
  } else {
    return -1;
  }
};
